import styles from "../Cadastro/Styles/CadastroPovosDaFloresta.module.scss";
import { useEffect, useState } from "react";
// import logo from "../../assets/logo_aldeia.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faEye,
  faEyeSlash,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { Input } from "../../components/Input/Input";
import Checkbox from "../../components/Checkbox/Checkbox";
import Radio from "../../components/Radio/Radio";
import Select from "../../components/Select/Select";
import { validaCpf, validaData } from "../../components/validacoes";
import Swal from "sweetalert2";
import { swalTheme, Toast } from "../../services/Swal";

import { ContainedBtn, OutlineBtn } from "../../components/ButtonTypes/Button";

import povos from "../../assets/povosIndigenas.json";

import {
  AlignRight,
  InputArea,
  InputAreaDupla,
} from "../../components/Box/Box";
import Widget, { setWidgetIsOpen } from "../../components/Widget/Widget";

function CadastroPovosDaFloresta() {
  const [termos, setTermos] = useState();
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [toggleSenha, setToggleSenha] = useState(false);
  const [form, setForm] = useState({
    nacionalidade: "Brasileiro",
  });

  const subButtonStyle = { fontSize: ".6em", padding: ".3em .5em", margin: ".1em" }

  function checkSenha(
    password,
    ifWrong = () => {
      Toast.fire({
        icon: "error",
        title:
          "A senha deverá conter oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial.",
      });
      setForm({
        ...form,
        senha: "",
      });
    }
  ) {
    if (!password) return;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (pattern.test(password)) return password;
    return ifWrong;
  }

  function checkCep(e) {
    const cep = e.target.value;
    if (!cep) return;
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((cep) => {
        if (cep.erro) {
          Toast.fire({
            icon: "info",
            title: "CEP não localizado",
          });
        } else {
          setForm({
            ...form,
            endereco: {
              ...form.endereco,
              logradouro: cep.logradouro,
              bairro: cep.bairro,
              complemento: cep.complemento,
              estado: cep.uf,
              cidade: cep.localidade,
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
        setForm({
          ...form,
          endereco: {
            ...form.endereco,
            cep: "",
          },
        });
        Toast.fire({
          icon: "error",
          title: "CEP inválido",
        });
      });
  }

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({ ...form, cpf: "" });
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  function handleDataNascimento(data) {
    if (!data) return;
    if (!validaData(data)) {
      setForm({ ...form, dataNascimento: "" });
      Toast.fire({
        icon: "error",
        title: "Data inválida",
      });
    }
  }

  async function selectEstado() {
    await fetch(process.env.REACT_APP_API_ESTADO)
      .then((response) => response.json())
      .then((data) => setEstados(data));
  }

  async function selectCidade(uf) {
    if (!uf) return;
    await fetch(`${process.env.REACT_APP_API_ESTADO}/${uf}/municipios`)
      .then((response) => response.json())
      .then((data) => setCidades(data));
  }

  useEffect(() => {
    selectEstado();
  }, []);

  useEffect(() => {
    selectCidade(form?.endereco?.estado);
  }, [form?.endereco?.estado]);

  async function getTermos() {
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=povosDaFloresta`
    )
      .then((response) => response.json())
      .then((data) => {
        setTermos(data.payload);
        //  console.log(data.payload);
      });
  }

  function validaTermos() {
    const termosObrigatorios = termos.filter((termo) => termo.obrigatorio);
    let validou = true;

    termosObrigatorios.map((termo) => {
      return !form.termos?.[termo.nome] ? (validou = false) : null;
    });

    if (validou) {
      submitForm(form);
    } else {
      Toast.fire({
        icon: "error",
        title:
          "O aceite dos termos de concentimento e política de dados Recode serão necessários.",
      });
    }
  }

  useEffect(() => {
    getTermos();
  }, []);

  async function submitForm(obj) {
    const termosEnviar = [];

    const keys = Object.keys(form?.termos);

    keys.map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: form?.termos[termo],
      });
    });


    console.warn({...obj, termos: termosEnviar});
    // console.warn(typeof(body.termos[0].aceite));

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({...obj, termos: termosEnviar}),
    };

    await fetch(`${process.env.REACT_APP_BACKEND}/api/PovosDaFloresta/CadastroEstudante`, request)
      .then((response) => response.text())
      .then((result) => {
        //console.log(result);
        result = JSON.parse(result);
        if (result.success)
          return Swal.fire({
            title: "Sucesso!",
            text: "O seu cadastro foi efetuado, acesse sua caixa de e-mail, confira nossa mensagem de confirmação e siga os próximos passos.",
            icon: "success",
            ...swalTheme,
          }).then(() => window.location.replace("https://povosdafloresta.recode.org.br/login/index.php"));

        return Swal.fire({
          title: "Erro",
          text: result.message,
          icon: "error",
          ...swalTheme,
        });
      })
      .catch((error) => {
        console.error("error", error);
        Swal.fire({
          title: "Erro",
          text: "Um erro ocorreu!",
          icon: "error",
          ...swalTheme,
        });
      });
  }

  const apenasLetras = "[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$";

  const [isWidgetLoading, setIsWidgetLoading] = useState(false)
  const [widgetForm, setWidgetForm] = useState({
    nome: "",
    email: "",
    assunto: "",
    projeto: "PovosDaFloresta",
    corpo: ""
  });

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: "Confirmação de senha inválida",
      });
      setForm({
        ...form,
        //senha: "",
        confirmaSenha: "",
      });
    }
  }

  function handleToggleSenha(e) {
    e.preventDefault();
    setToggleSenha(!toggleSenha);
  };

  async function submitWidget() {
    setIsWidgetLoading(true)
    console.log(widgetForm)
    await fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/DispararEmail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nomeRementente: widgetForm.nome,
        emailRemetente: widgetForm.email,
        projeto: widgetForm.projeto,
        assunto: widgetForm.assunto,
        corpo: widgetForm.corpo
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          Toast.fire({ icon: "success", title: "Sua mensagem foi enviada com sucesso!" });
          setWidgetForm({ nome: "", email: "", assunto: "", projeto: "QOT", corpo: "" })
        } else {
          Toast.fire({ icon: "warning", title: "Espere alguns instantes para enviar uma nova mensagem." });
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast.fire({ icon: "Erro", title: "Um erro ocorreu!" });
      })
      .finally(() => {
        setIsWidgetLoading(false)
        setWidgetIsOpen(false)
      });
  }


  return (
    <>
      <Widget
        content={
          <form
            style={{ display: "flex", gap: "5px", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              submitWidget();
            }}
          >
            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Nome"
                value={widgetForm.nome}
                onChange={(e) => setWidgetForm({ ...widgetForm, nome: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Email"
                type="email"
                placeholder="estudante@email.com"
                value={widgetForm.email}
                onChange={(e) => setWidgetForm({ ...widgetForm, email: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Select
                disabled={isWidgetLoading}
                className={styles.select}
                required
                label="Assunto"
                onChange={(e) => setWidgetForm({ ...widgetForm, assunto: e.target.value })}
              >
                <option>Elogio</option>
                <option>Dúvida</option>
                <option>Cadastro</option>
                <option>Problema técnico</option>
                <option>Outro</option>
              </Select>
            </InputArea>

            <InputArea>
              <textarea
                disabled={isWidgetLoading}
                className={styles.textarea}
                required
                rows={5}
                placeholder="Sua mensagem"
                value={widgetForm.corpo}
                onChange={(e) => setWidgetForm({ ...widgetForm, corpo: e.target.value })}
              ></textarea>
            </InputArea>

            <InputArea>
              <ContainedBtn className={styles.submitBtn} disabled={isWidgetLoading} > {!isWidgetLoading ? "Enviar" : "Enviando..."} </ContainedBtn>
            </InputArea>
          </form>
        }
      />

      <div className={styles.pseudo}>
        <section>
          {/* <img src="https://www.tudodesenhos.com/uploads/images/14680/papa-capim.jpg" className={styles.logo} alt="logo" /> */}
          <h1>Povos da Floresta</h1>
        </section>

        <hr className={styles.separador} />

        <form
          //noValidate={true}
          onSubmit={(e) => {
            e.preventDefault();
            validaTermos();
          }}
        >
          <section className={styles.formArea}>
            <InputAreaDupla>
              <Select
                className={styles.select}
                required
                label="Esse processo seletivo é destinado, exclusivamente, a indígenas, quilombolas e extrativistas parceiros do Instituto Conexão Povos da Floresta. Você preenche este pré-requisito?"
                onChange={(e) => setForm({ ...form, requisito: e.target.value })}
              >
                <option value="Indígenas">Sim, sou indígena parceiro do Conexão</option>
                <option value="Quilombolas">Sim, sou quilombola parceiro do Conexão</option>
                <option value="Extrativistas">Sim, sou extrativista do Conexão</option>
                <option value="Não">Não sou parceiro do Conexão</option>
              </Select>
            </InputAreaDupla>
          </section>

          {form?.requisito === "Não" && (
            <section className={styles.formArea}>
              <InputAreaDupla>
                <FontAwesomeIcon icon={faCircleXmark} /> Agradecemos seu interesse neste projeto, mas
                acreditamos que você possa continuar seus estudos em
                tecnologia através de nossa base de trilhas e cursos
                Recode, <a href="https://recode.org.br/prepareseparavoltar/">clicando aqui</a>
              </InputAreaDupla>
            </section>
          )}

          {(form?.requisito === "Indígenas" || form?.requisito === "Quilombolas" || form?.requisito === "Extrativistas") && (
            <>
              <section className={styles.formArea}>
                <InputArea>
                  <Input
                    className={styles.input}
                    pattern={apenasLetras}
                    required
                    label="Nome conforme documento de identificação oficial"
                    onChange={(e) =>
                      setForm({ ...form, nomeCompleto: e.target.value })
                    }
                    value={form.nomeCompleto}
                  />
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    pattern={apenasLetras}
                    label="Como você gostaria de ser chamado(a) em seu certificado e em nossa plataforma online?"
                    onChange={(e) =>
                      setForm({ ...form, nomeSocial: e.target.value })
                    }
                    value={form.nomeSocial}
                  />
                </InputArea>


                {form.requisito === "Indígenas" && (
                  <>
                    <InputAreaDupla>
                      <Select
                        className={styles.select}
                        required
                        label="Qual é o seu povo?"
                        onChange={(e) => setForm({ ...form, povo: e.target.value })}
                      >
                        {povos.povosIndigenas.sort((a, b) => a.localeCompare(b, 'pt-BR')).map((povo) => <option key={povo}> {povo} </option>)}
                        <option>Outro</option>
                      </Select>
                    </InputAreaDupla>

                    {form?.povo === "Outro" && (
                      <InputAreaDupla>
                        <Input
                          className={styles.input}
                          required
                          value={form.povoOutro}
                          label="Especifique"
                          onChange={(e) =>
                            setForm({ ...form, povoOutro: e.target.value })
                          }
                        />
                      </InputAreaDupla>
                    )}

                    <InputAreaDupla>
                      <Select
                        className={styles.select}
                        label="Qual o seu documento de comprovação de etnia indígena?"
                        subText="O Rani é um documento emitido pela Fundação Nacional do Índio (Funai)"
                        required
                        value={form.comprovacaoIndigena}
                        onChange={(e) =>
                          setForm({ ...form, comprovacaoIndigena: e.target.value })
                        }
                      >
                        <option key="Registro de Nascimento Indígena (Rani)" value="Registro de Nascimento Indígena (Rani)">Registro de Nascimento Indígena (Rani)</option>
                        <option key="Autodeclaração de pertencimento étnico indígena" value="Autodeclaração de pertencimento étnico indígena">Autodeclaração de pertencimento étnico indígena</option>
                      </Select>
                    </InputAreaDupla>

                    {form.comprovacaoIndigena === "Registro de Nascimento Indígena (Rani)" && (
                      <InputAreaDupla>
                        <Input
                          className={styles.input}
                          required
                          label="Qual é o número do seu Rani?"
                          value={form.rani}
                          onChange={(e) => setForm({ ...form, rani: e.target.value })}
                        />
                      </InputAreaDupla>
                    )}
                  </>
                )}

                {(form?.requisito === "Quilombolas" || form?.requisito === "Extrativistas") && (
                  <InputAreaDupla>
                    <Input
                      className={styles.input}
                      required
                      label="Qual sua comunidade?"
                      onChange={(e) =>
                        setForm({ ...form, comunidade: e.target.value })
                      }
                      value={form.comunidade}
                    />
                  </InputAreaDupla>
                )}

                <InputArea>
                  <Input
                    className={styles.input}
                    required
                    label="Data de nascimento"
                    type="date"
                    value={form.dataNascimento}
                    onChange={(e) =>
                      setForm({ ...form, dataNascimento: e.target.value })
                    }
                    onBlur={(e) => {
                      handleDataNascimento(e.target.value);
                    }}
                  />
                </InputArea>

                <InputArea>
                  <span className={styles.label}>Nacionalidade</span>
                  <div
                    onChange={(e) => {
                      const copia = { ...form };
                      delete copia.cpf;
                      delete copia.rg;
                      delete copia.documentoIdentificacao;
                      setForm({ ...copia, nacionalidade: e.target.value });
                    }}
                  >
                    <Radio
                      label="Brasileira"
                      name="nacionalidade"
                      value="Brasileiro"
                      defaultChecked
                      onChange={(e) =>
                        setForm({ ...form, nacionalidade: e.target.value })
                      }
                      className={styles.radio}
                    />

                    <Radio
                      label="Outra"
                      name="nacionalidade"
                      value="outro"
                      onChange={(e) =>
                        setForm({ ...form, nacionalidade: e.target.value })
                      }
                      className={styles.radio}
                    />
                  </div>
                </InputArea>

                {form?.nacionalidade !== "outro" && (
                  <>
                    <InputArea>
                      <Input
                        className={styles.input}
                        required
                        label="CPF"
                        mask="999.999.999-99"
                        placeholder="000.000.000-00"
                        value={form.cpf}
                        onChange={(e) =>
                          setForm({ ...form, cpf: e.target.value })
                        }
                        onBlur={(e) => {
                          handleCPF(e.target.value);
                        }}
                      />
                    </InputArea>

                    <InputArea>
                      <Input
                        className={styles.input}
                        required
                        label="RG"
                        value={form.rg}
                        onChange={(e) => setForm({ ...form, rg: e.target.value })}
                      />
                    </InputArea>
                  </>
                )}

                {form?.nacionalidade === "outro" && (
                  <>
                    <InputArea>
                      <Input
                        className={styles.input}
                        required
                        label="Insira sua nacionalidade"
                        value={form.nacionalidadeOutro}
                        onChange={(e) => setForm({ ...form, nacionalidadeOutro: e.target.value })}
                      />
                    </InputArea>

                    <InputArea>
                      <Input
                        className={styles.input}
                        required
                        label="Documento de Identificação (RNE)"
                        value={form.documentoIdentificacao}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            documentoIdentificacao: e.target.value,
                          })
                        }
                      />
                    </InputArea>
                  </>
                )}

                <InputAreaDupla>
                  <Input
                    className={styles.input}
                    required
                    label="E-mail pessoal"
                    type="email"
                    placeholder="estudante@email.com"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                  />
                </InputAreaDupla>

                <InputArea>
                  <Input
                    className={styles.input}
                    label="Telefone"
                    type="tel"
                    mask="(99) 99999-9999"
                    placeholder="(00) 12345-6789"
                    value={form.telefone}
                    onChange={(e) =>
                      setForm({ ...form, telefone: e.target.value })
                    }
                  />
                </InputArea>

                <InputArea>
                  <span className={styles.label}>Whatsapp</span>
                  <div>
                    <Checkbox
                      label="Este telefone é meu whatsapp"
                      name="whatsapp"
                      //value="sim"
                      className={styles.checkbox}
                      checked={form.whatsapp}
                      onChange={(e) =>
                        setForm({ ...form, whatsapp: e.target.checked })
                      }
                    >
                      Este telefone é meu whatsapp
                    </Checkbox>
                  </div>
                </InputArea>

                <InputAreaDupla>
                  <h1>Endereço</h1>
                  <hr className={styles.separador} />
                </InputAreaDupla>

                {/* Endereço */}
                <InputAreaDupla>
                  <Input
                    className={styles.input}
                    label="CEP"
                    mask="99999-999"
                    placeholder="00000-000"
                    value={form.endereco?.cep}
                    onBlur={checkCep}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, cep: e.target.value },
                      })
                    }
                  />
                </InputAreaDupla>

                <InputArea>
                  <Select
                    className={styles.select}
                    label="Estado"
                    required
                    value={form.endereco?.estado}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, estado: e.target.value },
                      })
                    }
                  >
                    {estados
                      .sort((a, b) =>
                        a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
                      )
                      .map((estado) => (
                        <option key={estado.id} value={estado.sigla}>
                          {estado.sigla}
                        </option>
                      ))}
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    label="Cidade"
                    value={form.endereco?.cidade}
                    required
                    disabled={!form?.endereco?.estado}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, cidade: e.target.value },
                      })
                    }
                  >
                    {cidades
                      .sort((a, b) =>
                        a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
                      )
                      .map((cidade) => (
                        <option key={cidade.id} value={cidade.sigla}>
                          {cidade.nome}
                        </option>
                      ))}
                  </Select>
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    label="Bairro"
                    value={form.endereco?.bairro}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, bairro: e.target.value },
                      })
                    }
                  />
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    label="Rua"
                    value={form.endereco?.logradouro}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, logradouro: e.target.value },
                      })
                    }
                  />
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    label="Número"
                    value={form.endereco?.numero}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: { ...form.endereco, numero: e.target.value },
                      })
                    }
                  />
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    label="Complemento"
                    value={form.endereco?.complemento}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        endereco: {
                          ...form.endereco,
                          complemento: e.target.value,
                        },
                      })
                    }
                  />
                </InputArea>
                {/* Endereço */}

                <InputAreaDupla>
                  <h1>Dados sociodemográfcos</h1>
                  <hr className={styles.separador} />
                </InputAreaDupla>


                <InputAreaDupla>
                  <Select
                    className={styles.select}
                    required
                    // label="Como se identifca em relação ao seu gênero?"
                    label="Como se identifica em relação ao seu gênero?"
                    onChange={(e) => setForm({ ...form, genero: e.target.value })}
                  >
                    <option>Homem</option>
                    <option>Homem Trans</option>
                    <option>Mulher</option>
                    <option>Mulher Trans</option>
                    <option>Prefiro não informar</option>
                    <option>Outro</option>
                  </Select>
                </InputAreaDupla>

                {form.genero === "Outro" && (

                  <InputAreaDupla>
                    <Input
                      required
                      className={styles.input}
                      value={form.generoOutro}
                      label="Qual?"
                      onChange={(e) => setForm({ ...form, generoOutro: e.target.value })}
                    />
                  </InputAreaDupla>
                )}

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    // label="Você se identifca como LGBTQIAPN+?"
                    label="Você se identifica como LGBTQIAPN+?"
                    subText="A sigla LGBTQIAPN+ representa pessoas que são Lésbicas, Gays, Bissexuais, Transexuais, Queer, Intersexo, Assexuais, Pansexuais e Não-binárias."
                    onChange={(e) => setForm({ ...form, lgbt: e.target.value })}
                  >
                    <option>Sim</option>
                    <option>Não</option>
                    <option>Prefiro não informar</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Você é uma pessoa com defciência?"
                    onChange={(e) => setForm({ ...form, pcd: e.target.value })}
                  >
                    <option>Não</option>
                    <option>Sim, defciência auditiva</option>
                    <option>Sim, defciência visual</option>
                    <option>Sim, defciência física</option>
                    <option>Sim, defciência intelectual</option>
                    <option>Prefiro não informar</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Você se considera refugiado(a)?"
                    onChange={(e) =>
                      setForm({ ...form, refugiado: e.target.value })
                    }
                    subText="Refugiado/a é a pessoa que está “fora de seu país de origem devido a fundados temores de perseguição relacionados a questões de raça, religião, nacionalidade, pertencimento a um determinado grupo social ou opinião política, como também devido à grave e generalizada violação de direitos humanos e conflitos armados”, segundo a ACNUR, Agência da ONU para Refugiados."
                  >
                    <option>Sim</option>
                    <option>Não</option>
                    <option>Prefiro não responder</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Qual seu nível de escolaridade?"
                    onChange={(e) => setForm({ ...form, escolaridade: e.target.value })}
                  >
                    <option>Ensino Médio incompleto</option>
                    <option>Ensino Médio completo</option>
                    <option>Graduação incompleta</option>
                    <option>Graduação completa</option>
                    <option>Pós-graduação incompleta ou mais</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Como é seu acesso à internet?"
                    subText="Nossos encontros de mentoria acontecerão de forma online, ao vivo, via ferramentas para chamadas em grupo. Assim, você precisa ter acesso à internet com banda larga fixa ou móvel de ao menos 4Mb (quatro megabytes) de velocidade."
                    onChange={(e) => setForm({ ...form, temInternet: e.target.value })}
                  >
                    <option>Estável para reuniões online</option>
                    <option>Instável para reuniões online</option>
                    <option>Ainda não sei</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Você tem um notebook próprio ou comunitário disponível para a realização das trilhas online e dos encontros a serem agendados?"
                    subText="É preciso que o computador/notebook esteja disponível para você no turno escolhido, pois as aulas acontecem de modo remoto, ao vivo. E o equipamento deve ter, no mínimo, a seguinte confguração: processador Core i5, 8gb de memória RAM, SSD 180gb ou superior"
                    onChange={(e) => setForm({ ...form, temComputador: e.target.value })}
                  >
                    <option>Sim</option>
                    <option>Não</option>
                  </Select>
                </InputArea>

                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Nossos encontros agendados de 2 horas por semana acontecerão entre os meses de agosto e novembro. Além deles, estimamos que você precise também de cerca de 1 hora por semana para realizar as trilhas online de forma autônoma. Você poderá participar deste projeto com a carga horária semanal total de 3 horas?"
                    onChange={(e) => setForm({ ...form, disponibilidade: e.target.value })}
                  >
                    <option>Sim</option>
                    <option>Não</option>
                    <option>Não sei</option>
                  </Select>
                </InputArea>


                <InputArea>
                  <Select
                    className={styles.select}
                    required
                    label="Como você ficou sabendo deste projeto?"
                    onChange={(e) =>
                      setForm({ ...form, ficouSabendo: e.target.value })
                    }
                  >
                    <option>Através do GT Educação/Letramento Digital</option>
                    <option>Através de entidade indígena</option>
                    <option>Através de entidade quilombola</option>
                    <option>Através de entidade extrativista</option>
                    <option>indicação de amigos e parentes</option>

                  </Select>
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    required
                    value={form.senha}
                    label="Senha"
                    type={toggleSenha ? "text" : "password"}
                    onChange={(e) => setForm({ ...form, senha: e.target.value })}
                    onBlur={checkSenha(form.senha)}
                    subText="A senha deverá conter no mínimo oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial."
                  />
                </InputArea>

                <InputArea>
                  <Input
                    className={styles.input}
                    required

                    value={form.confirmaSenha}
                    label="Confirmação de Senha"
                    type={toggleSenha ? "text" : "password"}
                    onChange={(e) => setForm({ ...form, confirmaSenha: e.target.value })}
                    onBlur={() => validaSenha(form.senha, form.confirmaSenha)}
                    subButton={
                      <OutlineBtn
                        onClick={handleToggleSenha}
                        className={styles.inputBtn}
                        style={subButtonStyle}
                      >
                        {toggleSenha ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                      </OutlineBtn>
                    }
                  />
                </InputArea>


                {termos
                  .sort((a, b) =>
                    a.obrigatorio > b.obrigatorio
                      ? 1
                      : b.obrigatorio > a.obrigatorio
                        ? -1
                        : 0
                  )
                  .map((termo, index) => (
                    <InputAreaDupla key={index}>
                      <Checkbox
                        key={termo.nome}
                        className={styles.checkbox}
                        // value={form[termo.nome]}
                        checked={form?.termos?.[termo?.nome]}
                        onChange={(e) => {
                          setForm({
                            ...form,
                            termos: {
                              ...form.termos,
                              [termo.nome]: e.target.checked,
                            },
                          });
                        }}
                        required
                      >
                        <span>
                          {termo.descricao}
                          {termo.obrigatorio && "* "}
                          {termo.link && (
                            <a
                              className={styles.checkboxA}
                              rel="noreferrer"
                              href={termo.link}
                              target="_blank"
                            >
                              <FontAwesomeIcon
                                icon={faUpRightFromSquare}
                                className={styles.icon}
                              />
                            </a>
                          )}
                        </span>
                      </Checkbox>
                    </InputAreaDupla>
                  ))}
              </section>
              <AlignRight>
                <ContainedBtn className={styles.submitBtn}>Enviar</ContainedBtn>
              </AlignRight>
            </>
          )}
        </form>
      </div>
    </>
  );
}

export default CadastroPovosDaFloresta;
